






















































































































import { Component, Mixins, Vue, Watch, Prop } from 'vue-property-decorator';
import { SettingsService } from '../api/SettingsService';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    AuthStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import multiselect from 'vue-multiselect';
import { EventBus, formatList, TypeEventBus } from '../../core/utils';
import SectionTitle from '../../core/components/SectionTitle.vue';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
@Component({
    components: { Loading, multiselect, SectionTitle, Input, SimpleTable }
})
export default class VehiclesDialog extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    AuthStoreHelper
) {
    @Prop({ default: () => {} })
    selectedVehicleForEdition: any;

    selectedVehicle: any[] = [];
    showChangeDeviceModal: boolean = true;

    @Watch('showChangeDeviceModal')
    modalVisibleObservable(value) {
        if (!value) this.$emit('closeModal');
    }
    selectedCompany: any = {};

    allCompanies: boolean = false;
    pendingRequest: boolean = false;

    selectedCompanyName: string;

    vehiclesOfSelectedCompany: any = [];

    search: string = '';
    sortBy: string[] = ['id'];
    sortDesc: boolean[] = [false];
    selectedItem: any = [];
    headers: any[] = [
        {
            text: 'Vehiculo',
            align: 'left',
            value: 'description'
        },
        {
            text: 'VIN',
            align: 'left',
            value: 'vin'
        },
        {
            text: 'Matricula',
            align: 'left',
            value: 'vehicle_plate'
        },
        {
            text: 'Empresas',
            align: 'left',
            value: 'companies',
            sortable: false
        }
    ];

    updateSelectedItem(row){
        this.selectedItem = row;
    }
    updateSearchValue(value){
        this.search = value;
    }

    getVehiclesList() {
        let self = this;
        SettingsService.getVehiclesList(this.getSelectedCompany() as string, this.allCompanies as boolean)
            .then(data => {
                self.resetSelectedItem();
                self.vehiclesOfSelectedCompany = data;
            })
            .catch(err => {
                // console.log(err);
            })
            .finally(() => {
                this.pendingRequest = false;
            });
        this.pendingRequest = true;
    }

    @Watch('selectedVehicleForEdition')
    call() {
        this.getSelectedVehicleForEdition;
    }

    get getSelectedVehicleForEdition() {
        this.selectedVehicle.push(this.selectedVehicleForEdition);
        return this.selectedVehicle;
    }

    get itemsSelectedVehicle() {
        let items:Array<object> = [];

        if(this.getSelectedVehicleForEdition.length == 1){
            items = this.getSelectedVehicleForEdition;
            const ids = items[0]['companies'].map(x => x.toString());
            const companies = this.$_getCompanies.filter(i => ids.includes(i.id));
            const companyNames = companies.map(company => `${company.name}`);
            items[0]['companies'] = companyNames;
        }

        return items
    }
    


    get getSelectedCompanyVehiclesList() {
        return this.vehiclesOfSelectedCompany.filter(vehicle => {
            return vehicle.id != this.getSelectedVehicleForEdition[0].id;
        });
    }

    getSelectedCompany() {
        return this.selectedCompany.id;
    }

    get sortedCompanies() {
        if (this.selectedCompany && this.selectedCompany.id !== null) {
            return this.$_getCompanies.sort((a, b) => {
                return this.selectedCompany.id == a.id
                    ? -1
                    : this.selectedCompany.id == b.id
                    ? 1
                    : a.name > b.name
                    ? 1
                    : -1;
            });
        }
        return this.$_getCompanies;
    }

    get canChangeEquipment() {
        return Boolean(this.selectedItem.length);
    }

    resetSelectedItem() {
        this.selectedItem = [];
    }

    async changeEquipment() {
        try {
            this.pendingRequest = true;
            const response = await SettingsService.changeEquipment({
                first_vehicle_id: this.getSelectedVehicleForEdition[0].id,
                second_vehicle_id: this.selectedItem[0].id
            });
            this.pendingRequest = false;
            this.$_successPatchRecipients(response.message);
            this.emitChange();
            EventBus.$emit(TypeEventBus.CALL_COMPANIES_ON_HOME_PAGE);
            setTimeout(() => {
                this.showChangeDeviceModal = false;
            }, 500);
        } catch (e) {
            this.$_showHistoricalError(e);
        }
    }

    emitChange() {
        this.$emit('submitChange');
    }

    unsubscribe: () => void;

    get getOperationsPermission() {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.OPERATIONS, PRIVILEGE_TYPES.EDIT_AND_DELETE);
    }

    seeAllCompanies() {
        if (this.getOperationsPermission) this.allCompanies = true;
    }

    created() {
        this.seeAllCompanies();
        let defaultCompanyId = 55;
        this.selectedCompany = {
            id: defaultCompanyId,
            name: this.$_getCompanies.filter(obj => {
                return obj.id == defaultCompanyId;
            })[0].name
        };
        this.getVehiclesList();
    }
}
